import { connect } from "react-redux";
import { compose } from "recompose";
import { withTranslation } from "react-i18next";
import {
  getFamilyDevices,
  getOtherDevices
} from "src/modules/device/duck/selectors";
import {
  getFamilyName,
  getDeviceName,
  getXmppLogin,
  getDeviceOriginalName
} from "src/modules/auth/duck/selectors";
import DeviceList from "./DeviceList";

function mapStateToProps(state) {
  return {
    familyDevices: getFamilyDevices(state),
    otherDevices: getOtherDevices(state),
    familyName: getFamilyName(state),
    thisDevice: {
      name: getDeviceName(state),
      originalName: getDeviceOriginalName(state),
      jid: getXmppLogin(state)
    }
  };
}

const enhance = compose(withTranslation(), connect(mapStateToProps));

export default enhance(DeviceList);
